const getRuntimeConfig = () => {
  if (typeof window !== "undefined" && window.APP_CONFIG) {
    console.log("📁 Runtime config loaded:", window.APP_CONFIG);
    return { ...window.APP_CONFIG };
  }

  console.warn("⚠️ window.APP_CONFIG not found, using fallback config");
  return {
    INTERPRETER_BASE_URL: "https://localhost:8006",
    VISUALIZER_BASE_URL: "https://localhost:8001",
    MODE: "development",
  };
};

export const runtimeConfig = getRuntimeConfig();

export const { INTERPRETER_BASE_URL, VISUALIZER_BASE_URL, MODE } = runtimeConfig;
